import { render, staticRenderFns } from "./ModalDelete.vue?vue&type=template&id=505e7370&scoped=true&"
import script from "./ModalDelete.ts?vue&type=script&lang=ts&"
export * from "./ModalDelete.ts?vue&type=script&lang=ts&"
import style0 from "./ModalDelete.vue?vue&type=style&index=0&id=505e7370&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505e7370",
  null
  
)

export default component.exports